<template>
  <div class="tabs">
    <div class="tabs-bar">
      <div class="tabs-nav-container">
        <div class="tabs-nav-wrap" ref="navWrap" :class="[scrollable ? 'tabs-nav-scrollable': '']">
          <span class="tabs-nav-prev " :class="[scrollable ? '': 'tabs-nav-scroll-disabled']" @click="scrollPrev">
            <i class="am-icon am-icon-ios-arrow-back"></i>
          </span>
          <span class="tabs-nav-next " :class="[scrollable ? '': 'tabs-nav-scroll-disabled']" @click="scrollNext">
            <i class="am-icon am-icon-ios-arrow-forward"></i>
          </span>
          <div class="tabs-nav-scroll" ref="navScroll">
            <div class="tabs-nav am-cf" ref="nav" :style="navStyle">
              <div class="tabs-link-bar" :style="barStyle"></div>
              <div class="tabs-tab" v-for="(item, index) in navList" @click="handleChange(index)" :key="index">{{item.label}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs-content tab-content-animated" :style="contentStyle" ref="panes">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  const prefixCls = 'tabs';
  const transitionTime = 300; // from CSS
  const getNextTab = (list, activeKey, direction, countDisabledAlso) => {
    const currentIndex = list.findIndex(tab => tab.name === activeKey);
    const nextIndex = (currentIndex + direction + list.length) % list.length;
    const nextTab = list[nextIndex];
    if (nextTab.disabled) return getNextTab(list, nextTab.name, direction, countDisabledAlso);
    else return nextTab;
  };
  const focusFirst = (element, root) => {
    try {element.focus();}
    catch(err) {} // eslint-disable-line no-empty

    if (document.activeElement == element && element !== root) return true;

    const candidates = element.children;
    for (let candidate of candidates) {
      if (focusFirst(candidate, root)) return true;
    }
    return false;
  };
  export default {
    name: 'Tabs',
    props: {
      value: {
        type: [String, Number]
      }
    },
    created() {
    },
    data() {
      return {
        type: 'line',
        animated: true,
        prefixCls: prefixCls,
        navList: [],
        barWidth: 0,
        barOffset: 0,
        activeKey: this.value,
        focusedKey: this.value,
        showSlot: false,
        navStyle: {
          transform: ''
        },
        scrollable: false,
        transitioning: false,
      }
    },
    mounted() {
    },
    computed: {
      contentStyle () {
        const x = this.getTabIndex(this.activeKey);
        const p = x === 0 ? '0%' : `-${x}00%`;

        let style = {};
        if (x > -1) {
          style = {
            transform: `translateX(${p}) translateZ(0px)`
          };
        }
        return style;
      },
      barStyle () {
        let style = {
          visibility: 'hidden',
          width: `${this.barWidth}px`
        };
        if (this.type === 'line') style.visibility = 'visible';
        if (this.animated) {
          style.transform = `translate3d(${this.barOffset}px, 0px, 0px)`;
        } else {
          style.left = `${this.barOffset}px`;
        }

        return style;
      }
    },
    methods: {
      getTabs () {
        return this.$children.filter(item => item.$options.name === 'TabPane');
      },
      updateNav () {
        this.navList = [];
        this.getTabs().forEach((pane, index) => {
          this.navList.push({
            label: pane.label,
            name: pane.currentName || index,
            disabled: pane.disabled,
          });
          if (!pane.currentName) pane.currentName = index;
          if (index === 0) {
            if (!this.activeKey) this.activeKey = pane.currentName || index;
          }
        });
        this.updateStatus();
        this.updateBar();
      },
      updateBar () {
        this.$nextTick(() => {
          const index = this.getTabIndex(this.activeKey);
          if (!this.$refs.nav) return;  // 页面销毁时，这里会报错，为了解决 #2100
          const prevTabs = this.$refs.nav.querySelectorAll(`.${prefixCls}-tab`);
          const tab = prevTabs[index];
          this.barWidth = tab ? parseFloat(tab.offsetWidth) : 0;

          if (index > 0) {
            let offset = 0;
            const gutter = this.size === 'small' ? 0 : 16;
            for (let i = 0; i < index; i++) {
              offset += parseFloat(prevTabs[i].offsetWidth) + gutter;
            }
            this.barOffset = offset;
          } else {
            this.barOffset = 0;
          }
          this.updateNavScroll();
        });
      },
      updateStatus () {
        const tabs = this.getTabs();
        tabs.forEach(tab => tab.show = (tab.currentName === this.activeKey) || this.animated);
      },
      getTabIndex(name){
        return this.navList.findIndex(nav => nav.name === name);
      },
      updateNavScroll(){
        const navWidth = this.$refs.nav.offsetWidth;
        const containerWidth = this.$refs.navScroll.offsetWidth;
        const currentOffset = this.getCurrentScrollOffset();
        if (containerWidth < navWidth) {
          this.scrollable = true;
          if (navWidth - currentOffset < containerWidth) {
            this.setOffset(navWidth - containerWidth);
          }
        } else {
          this.scrollable = false;
          if (currentOffset > 0) {
            this.setOffset(0);
          }
        }
      },
      setOffset(value) {
        this.navStyle.transform = `translateX(-${value}px)`;
      },
      getCurrentScrollOffset() {
        const { navStyle } = this;
        return navStyle.transform
          ? Number(navStyle.transform.match(/translateX\(-(\d+(\.\d+)*)px\)/)[1])
          : 0;
      },
      handleChange (index) {
        if (this.transitioning) return;
        this.transitioning = true;
        setTimeout(() => this.transitioning = false, transitionTime);
        const nav = this.navList[index];
        if (nav.disabled) return;
        this.activeKey = nav.name;
        this.$emit('input', nav.name);
        this.$emit('on-click', nav.name);
      },
      scrollToActiveTab() {
        if (!this.scrollable) return;
        const nav = this.$refs.nav;
        const activeTab = this.$el.querySelector(`.${prefixCls}-tab-active`);
        if(!activeTab) return;

        const navScroll = this.$refs.navScroll;
        const activeTabBounding = activeTab.getBoundingClientRect();
        const navScrollBounding = navScroll.getBoundingClientRect();
        const navBounding = nav.getBoundingClientRect();
        const currentOffset = this.getCurrentScrollOffset();
        let newOffset = currentOffset;

        if (navBounding.right < navScrollBounding.right) {
          newOffset = nav.offsetWidth - navScrollBounding.width;
        }

        if (activeTabBounding.left < navScrollBounding.left) {
          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
        }else if (activeTabBounding.right > navScrollBounding.right) {
          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
        }

        if(currentOffset !== newOffset){
          this.setOffset(Math.max(newOffset, 0));
        }
      },
      updateVisibility(index){
        [...this.$refs.panes.children].forEach((el, i) => {
          if (index === i) {
            [...el.children].filter(child=> child.classList.contains(`${prefixCls}-tabpane`)).forEach(child => child.style.visibility = 'visible');
            if (this.captureFocus) setTimeout(() => focusFirst(el, el), transitionTime);
          } else {
            setTimeout(() => {
              [...el.children].filter(child=> child.classList.contains(`${prefixCls}-tabpane`)).forEach(child => child.style.visibility = 'hidden');
            }, transitionTime);
          }
        });
      },
      scrollPrev() {
        const containerWidth = this.$refs.navScroll.offsetWidth;
        const currentOffset = this.getCurrentScrollOffset();

        if (!currentOffset) return;

        let newOffset = currentOffset > containerWidth
          ? currentOffset - containerWidth
          : 0;

        this.setOffset(newOffset);
      },
      scrollNext() {
        const navWidth = this.$refs.nav.offsetWidth;
        const containerWidth = this.$refs.navScroll.offsetWidth;
        const currentOffset = this.getCurrentScrollOffset();
        if (navWidth - currentOffset <= containerWidth) return;

        let newOffset = navWidth - currentOffset > containerWidth * 2
          ? currentOffset + containerWidth
          : (navWidth - containerWidth);

        this.setOffset(newOffset);
      }
    },
    watch: {
      value (val) {
        this.activeKey = val;
        this.focusedKey = val;
      },
      activeKey (val) {
        this.focusedKey = val;
        this.updateBar();
        this.updateStatus();
        // this.broadcast('Table', 'on-visible-change', true);
        this.$nextTick(() => {
          this.scrollToActiveTab();
        });
        // update visibility
        const nextIndex = Math.max(this.getTabIndex(this.focusedKey), 0);
        this.updateVisibility(nextIndex);
      }
    },
    destroyed() {
    }
  }
</script>

<style lang="less">
  .tabs {
    position: relative;
    overflow: hidden;
    color: #515a6e;
    zoom: 1;
    .tabs-bar {
      border-bottom: 1px solid #dcdee2;
      margin-bottom: 16px;
    }
    .tabs-nav-next {
      right: 0;
    }
    .tabs-nav-prev {
      left: 0;
    }
    .tabs-nav-scroll-disabled {
      display: none;
    }
    .tabs-nav-next,.tabs-nav-prev {
      position: absolute;
      line-height: 32px;
      cursor: pointer;
    }
    .tabs-nav-container {
      margin-bottom: -1px;
      line-height: 1.5;
      font-size: 14px;
      box-sizing: border-box;
      white-space: nowrap;
      overflow: hidden;
      position: relative;
      zoom: 1;
    }
    .tabs-nav-wrap {
      position: relative;
      overflow: hidden;
      margin-bottom: -1px;
    }
    .tabs-nav-scrollable {
      padding: 0 12px;
    }
    .tabs-nav-scroll {
      overflow: hidden;
      white-space: nowrap;
    }
    .tabs-nav {
      padding-left: 0;
      margin: 0;
      float: left;
      list-style: none;
      box-sizing: border-box;
      position: relative;
      transition: -webkit-transform .5s ease-in-out;
      transition: transform .5s ease-in-out;
    }
    .tabs-tab{
      display: inline-block;
      height: 100%;
      padding: 8px 16px;
      margin-right: 16px;
      box-sizing: border-box;
      cursor: pointer;
      text-decoration: none;
      position: relative;
      transition: color .3s ease-in-out;
    }
    .tabs-link-bar {
      visibility: visible;
      width: 74px;
      transform: translate3d(201px, 0px, 0px);
      height: 2px;
      box-sizing: border-box;
      background-color: #2d8cf0;
      position: absolute;
      left: 0;
      bottom: 1px;
      z-index: 1;
      transition: -webkit-transform .3s ease-in-out;
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
    }
    .tabs-tab-active {
      color: #2d8cf0;
    }
    .tab-content-animated {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      will-change: transform;
      transition: transform .3s ease-in-out;
    }
    .tabs-tabpane {
      -ms-flex-negative: 0;
      flex-shrink: 0;
      width: 100%;
      transition: opacity .3s;
      opacity: 1;
      outline: 0;
    }
  }
</style>




// WEBPACK FOOTER //
// components/Tabs/Tabs.vue